import BigNumber from 'bignumber.js';
import { ReadProvider, TChainId, vaultConfiguration } from 'modules/api';
import abi from './BoringLensABI';
import { ZERO } from 'modules/common/const';

export async function getShareValue(provider: ReadProvider) {
  const contract = provider.createContract<typeof abi>(
    abi,
    vaultConfiguration.lensContract,
  );

  const chainId = provider.chainId as TChainId;

  try {
    const shareValue = await contract.methods
      .exchangeRate(vaultConfiguration.getAccountantContract())
      .call();

    return new BigNumber(shareValue.toString()).div(
      new BigNumber(10).pow(vaultConfiguration.getBaseAsset(chainId).decimals),
    );
  } catch (error) {
    console.log(error);

    return new BigNumber(ZERO);
  }
}
